import { Button } from '~shared/ui/button';

interface Props {
  nextButtonDisabled?: boolean;
  onClickPrev?: () => void;
  isLastScreen?: boolean;
  isSubmitting?: boolean;
  onSubmitWithAction?: (
    event: React.FormEvent<HTMLFormElement>,
    action?: 'SUCCESS' | 'REJECT'
  ) => void;
}
export const FormFooter = ({
  nextButtonDisabled,
  onClickPrev,
  isLastScreen,
  isSubmitting = false,
  onSubmitWithAction,
}: Props) => {
  const isSubmitDisabled = nextButtonDisabled || isSubmitting;

  return (
    <div className="flex w-full items-center justify-between gap-3">
      {onClickPrev && (
        <Button
          wide
          size="m"
          type="button"
          theme="secondary"
          disableHorizontalPadding
          onClick={onClickPrev}
          disabled={isSubmitting}
        >
          Back
        </Button>
      )}
      {!isLastScreen && (
        <Button wide size="m" type="submit" disabled={nextButtonDisabled}>
          Next
        </Button>
      )}

      {isLastScreen && onSubmitWithAction && (
        <Button
          wide
          theme="outline"
          size="m"
          type="submit"
          disabled={isSubmitDisabled}
          onClick={(e) => {
            e.preventDefault();
            onSubmitWithAction(e, 'REJECT');
          }}
        >
          Reject
        </Button>
      )}
      {isLastScreen && (
        <Button
          wide
          size="m"
          type="submit"
          disabled={isSubmitDisabled}
          onClick={(e) => {
            if (onSubmitWithAction) {
              e.preventDefault();
              onSubmitWithAction(e, 'SUCCESS');
            }
          }}
        >
          Submit
        </Button>
      )}
    </div>
  );
};
